import { LitElement, html, css } from 'lit';

export class AcamFormEngine extends LitElement {
  static styles = css`
    :host {
      display: block;
      padding: 16px;
      background-color: lightgray;
      border-radius: 8px;
      text-align: center;
      font-family: Arial, sans-serif;
      color: var(--acam-form-engine-text-color, black);
    }
  `;

  static properties = {
    name: { type: String },
  };

  constructor() {
    super();
    this.name = 'World';
  }

  render() {
    return html`<p>Hello, ${this.name}!</p>`;
  }
}

customElements.define('acam-form-engine', AcamFormEngine);
